import { injectIntl, IntlShape } from 'react-intl';
import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { EventBlueprintsPresentation } from './event-blueprints.presentation';
import { EventBlueprintsVM } from './event-blueprints.viewmodel';
import { connectedBlueprintsVM } from '../blueprints.context';

export type ContainerProps = {
    accountId: number;
};

const EventBlueprintsContainer = injectIntl(withViewModel(
    EventBlueprintsPresentation,
    ({ accountId, intl }: ContainerProps & { intl: IntlShape}) => {
        const eventBlueprintsVM = new EventBlueprintsVM(accountId, intl);

        eventBlueprintsVM.initialize();

        return eventBlueprintsVM;
    },
    props => [ props.accountId ]
));

export const EventBlueprints = connectedBlueprintsVM<ContainerProps>(
    EventBlueprintsContainer,
    vm => ({
        accountId: vm.getAccountId()
    })
);
